import React from 'react'
import { Pagination } from 'antd'

import {
    DaySection,
    DayTitle,
    LessonList,
    ScheduleArea,
    StatusText,
} from '../../../components/scharedStyles/style'
import { formatScheduleDate } from '../../schedule/utils/formatScheduleDate'
import { getLesson } from '../utils/lessonHelpers'
import EditScheduleEditor from '../EditScheduleEditor'
import EditScheduleLessonCard from '../EditScheduleLessonCard'
import { PaginationWrap, AlertBanner } from '../style'
import { isEditingLesson, useEditScheduleList } from './useEditScheduleList'

const EditScheduleList = () => {
    const {
        alertClassIds,
        entries,
        loadingSchedule,
        totalItems,
        editingId,
        isCreating,
        currentPage,
        pageSize,
        editorRef,
        openEditEditor,
        handleDelete,
        changePage,
        changePageSize,
    } = useEditScheduleList()

    return (
        <ScheduleArea>
            {alertClassIds && (
                <AlertBanner as={StatusText}>
                    Показаны занятия из алерта
                </AlertBanner>
            )}

            {loadingSchedule ? (
                <StatusText>Загрузка...</StatusText>
            ) : entries.length === 0 && !isCreating ? (
                <StatusText>Нет данных для отображения</StatusText>
            ) : (
                <>
                    {isCreating && (
                        <DaySection>
                            <DayTitle>Новая запись</DayTitle>
                            <div ref={editorRef}>
                                <EditScheduleEditor isNew />
                            </div>
                        </DaySection>
                    )}

                    {entries.map(([date, items]) => (
                        <DaySection key={date}>
                            <DayTitle>{formatScheduleDate(date)}</DayTitle>

                            <LessonList>
                                {items.map((item, index) => {
                                    const lesson = getLesson(item)
                                    const classId = lesson?.class_id || item?.class_id
                                    const isEditing = isEditingLesson(item, editingId)

                                    if (isEditing) {
                                        return (
                                            <div key={classId || index} ref={editorRef}>
                                                <EditScheduleEditor item={item} lesson={lesson} />
                                            </div>
                                        )
                                    }

                                    return (
                                        <EditScheduleLessonCard
                                            key={classId || index}
                                            item={item}
                                            index={index}
                                            isEditing={isEditing}
                                            onEdit={openEditEditor}
                                            onDelete={handleDelete}
                                        />
                                    )
                                })}
                            </LessonList>
                        </DaySection>
                    ))}

                    {totalItems > 0 && (
                        <PaginationWrap>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={totalItems}
                                onChange={changePage}
                                onShowSizeChange={changePageSize}
                            />
                        </PaginationWrap>
                    )}
                </>
            )}
        </ScheduleArea>
    )
}

export default EditScheduleList
